import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';

import './image-links.scss';

export function ImageLinks({
  entry,
  imageSize,
  className,
  titleContainerClassName,
  titleClassName,
  imagesListClassName,
  imageCardClassName,
  imageClassName,
  imageTitleClassName,
}) {
  const { title, summary } = entry;
  const links = entry.children().map(link => ({
    href: link.metadata('item-link').value(),
    name: link.metadata('item-title').value(),
    image: link.metadata('item-image').value(),
  }));

  return (
    <div
      className={classnames(
        'image-links',
        {
          'align-center': entry.metadata('center-links').boolean(),
        },
        className
      )}
    >
      <SectionHeading
        linkout={{ href: entry.metadata('view-more-url').value() }}
        linkoutText={entry.metadata('view-more-title').value()}
        containerClassName={titleContainerClassName}
        textClassName={titleClassName}
      >
        {title}
      </SectionHeading>
      {!!summary && <p className="px-1 pt-0_75 pb-0 m-0">{summary}</p>}
      <ul className={classnames('list-unstyled image-links-items pt-0_5', imagesListClassName)}>
        {links.map(item => (
          <li key={item.name} className={classnames('image-links-item', imageCardClassName)}>
            <a href={item.href}>
              <img
                src={getFullImageUrl(item.image, imageSize)}
                alt=""
                className={classnames('mb-0_25 image-links-item-image', imageClassName)}
              />
              <p className={classnames('image-links-details', imageTitleClassName)}>{item.name}</p>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

ImageLinks.defaultProps = {
  className: null,
  imageSize: IMAGE_SIZES.xs,
  titleContainerClassName: undefined,
  titleClassName: undefined,
  imagesListClassName: 'px-0_5',
  imageCardClassName: 'p-0_5',
  imageClassName: null,
  imageTitleClassName: 'size-14 m-0',
  entry: DEFAULT_CONTENT,
};

ImageLinks.propTypes = {
  className: PropTypes.string,
  imageSize: PropTypes.number,
  titleContainerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  imagesListClassName: PropTypes.string,
  imageCardClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  imageTitleClassName: PropTypes.string,
  entry: CmsEntities.Content,
};
